<template>
    <transition name="fade">
            <router-view />
    </transition>
</template>

<script>
    export default {
        name: "Auth"
    }
</script>

<style>
    .show-me-later {
        display: block !important;
    }
</style>
